const products = [
    {
      id: 1,
      name: "Velvet Luxury Pillow",
      price: 49.99,
      category: "pillows",
      color: "red",
      brand: "luxe",
      image:
        "https://images.unsplash.com/photo-1738235455537-48e009d369a6?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
      isFeatured: true,
    },
    {
      id: 2,
      name: "Comfy Pillow Blue",
      price: 39.99,
      category: "pillows",
      color: "blue",
      brand: "cozy",
      image:
        "https://images.unsplash.com/photo-1586632207930-8145c26f0a11?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.2,
    },
    {
      id: 3,
      name: "Striped Cushion",
      price: 29.99,
      category: "pillows",
      color: "black",
      brand: "urban",
      image:
        "https://images.unsplash.com/photo-1658501238841-da09649a94f3?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.0,
      isFeatured: true,
    },
    {
      id: 4,
      name: "Floral Print Pillow",
      price: 34.99,
      category: "pillows",
      color: "white",
      brand: "nature",
      image:
        "https://images.unsplash.com/photo-1685397642289-384bc5a20acd?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.6,
    },
    {
      id: 5,
      name: "Round Velvet Cushion",
      price: 45.99,
      category: "pillows",
      color: "green",
      brand: "luxe",
      image:
        "https://images.unsplash.com/photo-1708936120452-6dffc2a096e1?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.4,
      isFeatured: true,
    },
    {
      id: 6,
      name: "Textured Beige Pillow",
      price: 31.99,
      category: "pillows",
      color: "beige",
      brand: "earthy",
      image:
        "https://images.unsplash.com/photo-1741308478073-11eef75acb79?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.1,
    },
    {
      id: 7,
      name: "Minimalist Pillow",
      price: 25.99,
      category: "pillows",
      color: "gray",
      brand: "zen",
      image:
        "https://images.unsplash.com/photo-1570786240066-c0d753711cfe?q=80&w=2081&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 3.9,
      isFeatured: true,
    },
    {
      id: 8,
      name: "Gold-Trim Pillow",
      price: 55.99,
      category: "pillows",
      color: "gold",
      brand: "luxe",
      image:
        "https://images.unsplash.com/photo-1661375519253-933bd56a0b2d?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.7,
    },
    {
      id: 9,
      name: "Kids Pillow Fun Print",
      price: 19.99,
      category: "pillows",
      color: "multi",
      brand: "fun",
      image:
        "https://images.unsplash.com/photo-1721330290338-6adbbc196aec?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.3,
      isFeatured: true,
    },
    {
      id: 10,
      name: "Luxury Silk Pillow",
      price: 64.99,
      category: "pillows",
      color: "white",
      brand: "silken",
      image:
        "https://images.unsplash.com/photo-1579889200258-cff19c1eb2a8?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.9,
    },
    {
      id: 11,
      name: "Modern Gray Curtain",
      price: 89.99,
      category: "curtains",
      color: "gray",
      brand: "elite",
      image:
        "https://images.unsplash.com/photo-1712172424730-be716283b2e0?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.6,
    },
    {
      id: 12,
      name: "Beige Linen Curtain",
      price: 79.99,
      category: "curtains",
      color: "beige",
      brand: "cozy",
      image:
        "https://images.unsplash.com/photo-1560186258-b543739444ed?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.3,
      isFeatured: true,
    },
    {
      id: 13,
      name: "Blackout Blue Curtains",
      price: 99.99,
      category: "curtains",
      color: "blue",
      brand: "shadepro",
      image:
        "https://images.unsplash.com/photo-1617547359449-533b7686cc03?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.8,
    },
    {
      id: 14,
      name: "Lace White Curtain",
      price: 59.99,
      category: "curtains",
      color: "white",
      brand: "elegant",
      image:
        "https://images.unsplash.com/photo-1718561651410-b0bd9bc0f119?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.0,
      isFeatured: true,
    },
    {
      id: 15,
      name: "Floral Window Curtains",
      price: 69.99,
      category: "curtains",
      color: "multi",
      brand: "florist",
      image:
        "https://images.unsplash.com/photo-1703242327538-919ac43a41b6?q=80&w=2105&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.2,
    },
    {
      id: 16,
      name: "Luxury Velvet Curtains",
      price: 110.99,
      category: "curtains",
      color: "green",
      brand: "luxe",
      image:
        "https://images.unsplash.com/photo-1648199144149-42e473a77af0?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.9,
      isFeatured: true,
    },
    {
      id: 17,
      name: "Minimalist Gray Curtains",
      price: 74.99,
      category: "curtains",
      color: "gray",
      brand: "zen",
      image:
        "https://images.unsplash.com/photo-1563006755-5d7c8e27cf7b?q=80&w=2127&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.1,
    },
    {
      id: 18,
      name: "Children’s Room Curtains",
      price: 54.99,
      category: "curtains",
      color: "yellow",
      brand: "kidsline",
      image:
        "https://images.unsplash.com/photo-1712172424864-1778f0cd34e0?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.0,
      isFeatured: true,
    },
    {
      id: 19,
      name: "Sheer Romantic Curtains",
      price: 65.0,
      category: "curtains",
      color: "pink",
      brand: "lovehome",
      image:
        "https://images.unsplash.com/photo-1706586344914-8870816c8725?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.4,
    },
    {
      id: 20,
      name: "Earthy Linen Drape",
      price: 85.99,
      category: "curtains",
      color: "brown",
      brand: "earthy",
      image:
        "https://images.unsplash.com/photo-1601307635204-6dfaae5d7b8c?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.6,
    },
    {
      id: 21,
      name: "Elegant Sofa Cover",
      price: 59.99,
      category: "sofa-covers",
      color: "blue",
      brand: "luxe",
      image:
        "https://images.unsplash.com/photo-1698936061086-2bf99c7b9fc5?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.4,
    },
    {
      id: 22,
      name: "Premium Sofa Cover",
      price: 64.99,
      category: "sofa-covers",
      color: "gray",
      brand: "elite",
      image:
        "https://images.unsplash.com/photo-1589999405517-d19e4c105649?q=80&w=2074&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.0,
    },
    {
      id: 23,
      name: "Linen Sofa Slipcover",
      price: 69.99,
      category: "sofa-covers",
      color: "white",
      brand: "cozy",
      image:
        "https://images.unsplash.com/photo-1698936061086-2bf99c7b9fc5?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
    },
    {
      id: 24,
      name: "Textured Gray Cover",
      price: 58.99,
      category: "sofa-covers",
      color: "gray",
      brand: "earthy",
      image:
        "https://images.unsplash.com/photo-1678794792867-565c9cd2fb55?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.2,
    },
    {
      id: 25,
      name: "Modern Sofa Protector",
      price: 75.99,
      category: "sofa-covers",
      color: "black",
      brand: "urban",
      image:
        "https://images.unsplash.com/photo-1653251307042-c5821df9d527?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.6,
    },
    {
      id: 26,
      name: "Printed Sofa Cover",
      price: 49.99,
      category: "sofa-covers",
      color: "multi",
      brand: "florist",
      image:
        "https://images.unsplash.com/photo-1579693004042-0f47ae6ce653?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.3,
    },
    {
      id: 27,
      name: "Kids Sofa Cover",
      price: 45.99,
      category: "sofa-covers",
      color: "yellow",
      brand: "kidsline",
      image:
        "https://images.unsplash.com/photo-1527585592113-6ec3ad3d2ac3?q=80&w=1931&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.0,
    },
    {
      id: 28,
      name: "Luxury Fabric Sofa Cover",
      price: 89.99,
      category: "sofa-covers",
      color: "green",
      brand: "luxe",
      image:
        "https://images.unsplash.com/photo-1655149555299-9f3052e48e7e?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.8,
    },
    {
      id: 29,
      name: "Waterproof Cover",
      price: 52.99,
      category: "sofa-covers",
      color: "beige",
      brand: "safehome",
      image:
        "https://images.unsplash.com/photo-1746048385662-955300f7bb2b?q=80&w=2054&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.4,
    },
    {
      id: 30,
      name: "Slip-resistant Sofa Cover",
      price: 60.0,
      category: "sofa-covers",
      color: "brown",
      brand: "earthy",
      image:
        "https://images.unsplash.com/photo-1607646175036-fdba5063cfed?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.3,
    },
    {
      id: 31,
      name: "Luxury Bedding Set",
      price: 119.99,
      category: "bedding",
      color: "white",
      brand: "elite",
      image:
        "https://images.unsplash.com/photo-1623175788405-46d2c0356c12?q=80&w=2065&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 5.0,
    },
    {
      id: 32,
      name: "Comfy Cotton Bedding",
      price: 99.99,
      category: "bedding",
      color: "beige",
      brand: "cozy",
      image:
        "https://images.unsplash.com/photo-1606855637183-ea2a00b6f15f?q=80&w=2000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.7,
    },
    {
      id: 33,
      name: "Minimalist Bed Set",
      price: 109.99,
      category: "bedding",
      color: "gray",
      brand: "zen",
      image:
        "https://images.unsplash.com/photo-1739293112418-9fb062917d68?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.6,
    },
    {
      id: 34,
      name: "Children Bedding Set",
      price: 89.99,
      category: "bedding",
      color: "blue",
      brand: "kidsline",
      image:
        "https://images.unsplash.com/photo-1691731052289-a81065740f77?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.4,
    },
    {
      id: 35,
      name: "Floral Print Bedding",
      price: 99.99,
      category: "bedding",
      color: "pink",
      brand: "florist",
      image:
        "https://images.unsplash.com/photo-1568911184350-13c9049c430c?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.3,
    },
    {
      id: 36,
      name: "Linen Bedding Set",
      price: 114.99,
      category: "bedding",
      color: "white",
      brand: "earthy",
      image:
        "https://images.unsplash.com/photo-1699436639670-1e5799b14aae?q=80&w=2075&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.8,
    },
    {
      id: 37,
      name: "Checkered Bed Sheets",
      price: 79.99,
      category: "bedding",
      color: "black",
      brand: "urban",
      image:
        "https://images.unsplash.com/photo-1686827986080-8ee55b055a2f?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.1,
    },
    {
      id: 38,
      name: "Silk Bedding",
      price: 129.99,
      category: "bedding",
      color: "gold",
      brand: "silken",
      image:
        "https://images.unsplash.com/photo-1606796913622-568a03126269?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 5.0,
    },
    {
      id: 39,
      name: "Geometric Duvet Set",
      price: 92.99,
      category: "bedding",
      color: "multi",
      brand: "modern",
      image:
        "https://images.unsplash.com/photo-1692530943891-589e88b780a1?q=80&w=1940&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.2,
    },
    {
      id: 40,
      name: "Earth Tones Bedding",
      price: 104.99,
      category: "bedding",
      color: "brown",
      brand: "earthy",
      image:
        "https://images.unsplash.com/photo-1631741779142-6c18e6b66b19?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      rating: 4.5,
    },
  ];
  export default products;